import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { EapSettingsFormHeaderStyled } from './eap-settings-form-header.style';

interface DeviceConfigurationHeaderProps {
    title: string;
    subtitle: string;
}

export const EapSettingsFormHeader: React.FC<DeviceConfigurationHeaderProps> = ({ title, subtitle }) => (
    <EapSettingsFormHeaderStyled>
        <div className="title">
            <PocTypography variant="title5">{title}</PocTypography>
            <PocTypography variant="body1">{subtitle}</PocTypography>
        </div>
    </EapSettingsFormHeaderStyled>
);
